import { Translation } from 'primeng/api';

export default {
  startsWith: 'Začíná na',
  contains: 'Obsahuje',
  notContains: 'Neobsahuje',
  endsWith: 'Končí na',
  equals: 'Je rovno',
  emptyMessage: 'Žádné výsledky',
  emptyFilterMessage: 'Žádné výsledky',
  dayNames: ['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota'],
  dayNamesShort: ['Ned', 'Pon', 'Úte', 'Stř', 'Čtv', 'Pát', 'Sob'],
  dayNamesMin: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
  monthNames: [
    'Leden',
    'Únor',
    'Březen',
    'Duben',
    'Květen',
    'Červen',
    'Červenec',
    'Srpen',
    'Září',
    'Říjen',
    'Listopad',
    'Prosinec',
  ],
  monthNamesShort: ['Led', 'Úno', 'Bře', 'Dub', 'Kvě', 'Čer', 'Čvc', 'Srp', 'Zář', 'Říj', 'Lis', 'Pro'],
  dateFormat: 'dd. mm. yy',
  firstDayOfWeek: 1,
  today: 'Dnes',
  weekHeader: 'Týd.',
} as Translation;
